import GraniteError from 'granite-admin/utils/granite-error';
import GraniteAPIClient from 'granite-admin/utils/granite-client';
import { getAuthToken } from 'granite-admin/utils/auth-singleton';

import BopisEntity from 'shopifyConfig/entities/Bopis';
import WarehouseEntity from 'shopifyConfig/entities/Warehouse';
import { ENDPOINTS } from 'shopifyConfig/gateways/endpoints';

/* eslint-disable */
const dropdownUrl = process.env.REACT_APP_SHOPIFY_DROPDOWN;
const quiversMiddlewareUrl = process.env.REACT_APP_QUIVERS_MIDDLEWARE_URL;
const quiversMiddlewareUrl2demo = process.env.REACT_APP_QUIVERS_MIDDLEWARE_URL_BOPISDEMO; 
const bopisDeactivateUrl = process.env.REACT_APP_BOPIS_DEACTIVATE_URL;
const ShopifyMiddlewareUrl = process.env.REACT_APP_SHOPIFY_MIDDLEWARE_URL;
const ShopifyMiddlewareFetchStoreCurrencyUrl = process.env.REACT_APP_MIDDLEWARE_FETCH_STORE_CURRENCY_URL;
const ShopifyMiddlewareFetchStoreSalesChannelsUrl = process.env.REACT_APP_MIDDLEWARE_FETCH_STORE_SALES_CHANNELS;
const listCustomizationsUrl = process.env.REACT_APP_QUIVERS_MIDDLEWARE_URL;

async function getWareHouses(business) {
  try {
    const { data } = await GraniteAPIClient(dropdownUrl, {
      Authorization: getAuthToken(),
    }).get(`Warehouses/Search?refId=${business}`);
    return data;
  } catch (e) {
    throw new GraniteError(e.errors);
  }
}

async function refreshWareHouses(payload) {
  try {
    const { data } = await GraniteAPIClient(quiversMiddlewareUrl).post(`serveAPI/`, payload);
    const parseData = JSON.parse(data.response);
    const list = parseData.locations.map(item => new WarehouseEntity(item));
    return list;
  } catch (e) {
    throw new GraniteError(e.errors);
  }
}

async function bopisMiddleware(params) {
  try {
    const { data } = await GraniteAPIClient(quiversMiddlewareUrl2demo).post(`/shopify-v2/pluginDataAPI`, params);
    const list = new BopisEntity(data);
    return list;
  } catch (e) {
    throw new GraniteError(e.errors);
  }
}

async function bopisDeactivateShop({ params }) {
  try {
    const { data } = await GraniteAPIClient(bopisDeactivateUrl).post(`/shop_deactivate`, params);
    return data;
  } catch (e) {
    throw new GraniteError(e.errors);
  }
}

async function getDashboardData(params) {
  try {
    const { data } = await GraniteAPIClient(quiversMiddlewareUrl, {
      Authorization: getAuthToken(),
    }).get(ENDPOINTS.DASHBOARD_STATS, {
      params: params,
    });
    return data;
  } catch (e) {
    throw new GraniteError(e.errors);
  }
}

/**
 * Sends a request to close the Shopify embedded app window by calling the specified Shopify middleware URL.
 * This function is intended for embedded Shopify apps to handle window closure requests.
 *
 * @param {EventEmitter} eventEmitter - The event emitter for notifying success or failure events.
 * This allows the application to respond to the API call’s result.
 * @param {Object} params - Parameters for the API request to close the Shopify window.
 * @param {string} params.id - A unique identifier for the session or operation, typically generated dynamically.
 * @param {string} params.ref_id - A reference ID to track the specific operation or transaction, often used for logging.
 * @param {string} params.shop - The subdomain of the Shopify store (e.g., 'test-paypal01') that will be used to identify the store.
 *
 */
async function closeShopifyWindow(params) {
  await GraniteAPIClient(ShopifyMiddlewareUrl).get(`/connect/`, {
    params,
  });
}

async function installShopifyWindow(params) {
  return (
    await GraniteAPIClient(ShopifyMiddlewareUrl).get(`/fetch_app/`, {
      params,
    })
  )?.data;
}

async function fetchStoreCurrency(params) {
  try {
    const { data } = await GraniteAPIClient(ShopifyMiddlewareUrl, { Authorization: getAuthToken() }).get(
      ShopifyMiddlewareFetchStoreCurrencyUrl,
      {
        params,
      },
    );
    return data;
  } catch (e) {
    throw new GraniteError(e.errors);
  }
}
async function fethcSalesChannels(params) {
  try {
    const { data } = await GraniteAPIClient(ShopifyMiddlewareUrl, { Authorization: getAuthToken() }).get(
      ShopifyMiddlewareFetchStoreSalesChannelsUrl,
      {
        params,
      },
    );
    return data;
  } catch (e) {
    throw new GraniteError(e.errors);
  }
}

async function listCustomizations(business, pluginRefId) {
  try {
    const params = { ref_id: business };
    if (pluginRefId) params.plugin_ref_id = pluginRefId;

    const { data } = await GraniteAPIClient(listCustomizationsUrl, {
      Authorization: getAuthToken(),
    }).get(`customizations/listall`, { params });
    return data;
  } catch (e) {
    throw new GraniteError(e.errors);
  }
}

export default {
  getWareHouses,
  bopisMiddleware,
  bopisDeactivateShop,
  getDashboardData,
  refreshWareHouses,
  closeShopifyWindow,
  installShopifyWindow,
  fetchStoreCurrency,
  fethcSalesChannels,
  listCustomizations,
};
